if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      /* TROCAR DE FOTO SEM CORTE SECO.

         A galeria e duas coisas diferentes, e cada uma pede uma transicao:

         - onde a lista ROLA (celular, e desktop com miniaturas em coluna), da
           para ir ate a foto passando pelas outras. E o movimento que liga a
           foto nova a anterior, em vez de trocar do nada.
         - onde o Dawn esconde todo slide que nao e o ativo com display:none
           (desktop com thumbnail/thumbnail_slider, ver section-main-product.css),
           nao existe caminho para percorrer: e troca de elemento, nao movimento.
           La a transicao e um fade curto no visor.

         130ms de propósito: acima de ~150ms deixa de parecer resposta ao clique
         e passa a parecer lentidao.

         Com `prefers-reduced-motion` nao ha nem fade nem rolagem animada — quem
         liga isso costuma ligar por enjoo ou vertigem, nao por gosto. */
      semMovimento() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      comFade(troca) {
        if (this.semMovimento()) {
          troca();
          return;
        }
        const visor = this.elements.viewer;
        visor.classList.add('media-gallery--fade', 'is-trocando');
        window.clearTimeout(this._fade);
        this._fade = window.setTimeout(() => {
          troca();
          /* Dois quadros: o primeiro deixa o navegador pintar o estado novo
             ainda apagado. Tirando a classe no mesmo quadro, ele funde a foto
             velha com a nova e o fade nao acontece. */
          requestAnimationFrame(() => {
            requestAnimationFrame(() => visor.classList.remove('is-trocando'));
          });
        }, 130);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }

        const lista = activeMedia.parentElement;
        const rola = lista.scrollWidth - lista.clientWidth > 8;
        const jaAtivo = activeMedia.classList.contains('is-active');

        const aplicar = () => {
          this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
          });
          activeMedia?.classList?.add('is-active');

          if (prepend) {
            activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

            if (this.elements.thumbnails) {
              const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
              activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
            }

            if (this.elements.viewer.slider) this.elements.viewer.resetPages();
          }
        };

        /* Onde a lista rola, a rolagem ja e a transicao e o fade so atrapalharia
           (a foto sumiria no meio do caminho). Ja ativo = nada a animar. */
        if (rola || jaAtivo) {
          aplicar();
        } else {
          this.comFade(aplicar);
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            lista.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: rola && !this.semMovimento() ? 'smooth' : 'auto',
            });
          }
          /* 16/10/2026 (Guilherme): escolher uma cor (troca de variante, prepend = true) NAO leva a pagina ate a
             galeria -- a tela nao se mexe sem a cliente pedir. A foto da cor so fica ativa na galeria, que ela ve quando
             subir. Clique na miniatura (prepend = false) continua como no Dawn. */
          if (prepend) return;
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
